module.exports = __webpack_public_path__ + "static/media/white-space-1800.b129a4a9.jpg";